// extracted by mini-css-extract-plugin
export default {"layout":"\"../../../styles/variables/layout.module.css\"","gap-xxs":"2px","button":"Base_button__pNggm","full":"Base_full__0by6U"};